import { SecurityDepositTableQuery } from 'src/app/shared/shared.model';
import { ResidentReference } from "../../residents/models/residents.model";

export class InvitesQuery extends SecurityDepositTableQuery<InviteQueryParameter>{
  residentName?: string;
  search?: string;
  statusCodes?: InviteStatusCode[];
}

export interface Invite {
  id?: string;
  statusCode?: InviteStatusCode;
  createTimeUtc?: Date;
  isRenewal?: boolean;
  resident?: ResidentReference;
  isReinviteAvailable?: boolean;
  isCloseAvailable?: boolean;
}

export class SendInvite {
  propertyManagerId?: string;
  apartment?: string;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  leaseTerm?: number;
  monthlyRent?: number;
  securityDepositAmount?: number;
  moveInDate?: Date;
  sendInviteEmail?: boolean;
  sendInviteSms?: boolean;
  preExistingTenant?: boolean;
  isRenewal?: boolean;
}

export class ResendInvites {
  resendInvites?: ResendInvite[];
}

export class ResendInvite {
  propertyId?: string;
  inviteId?: string;
  reinviteType?: ReinviteType;
}

export class CloseInvites {
  closeInvites?: CloseInvite[];
}

export class CloseInvite {
  inviteId?: string;
}

export class BulkUpload {
  propertyManagerId?: string;
  csvFile?: string;
}

export class InviteLink {
  title?: string;
  url?: string;
}

export class InviteLinkPreSelectedPropertyManager {
  propertyManagerName?: string;
  url?: string;
}

export class InviteLinks {
  globalInviteUrl?: string;
  propertyManagerPreSelectedGlobalLinks?: InviteLinkPreSelectedPropertyManager[];
}

export enum InviteQueryParameter {
  propertyManagerName = 1,
  apartment = 2,
  residentName = 3,
  status = 4,
  inviteDate = 5
}

export enum InviteType {
  invited = 1,
  readyToInvite = 2
}

export enum ReinviteType {
  email = 1,
  sms = 2
}

export enum InviteStatusCode {
  imported = 1,
  sent = 2,
  used = 3,
  closed = 4
}

export class InviteStatuses {
  static readonly IMPORTED = "Imported";
  static readonly INVITED = "Invited";
}
